import React, { useState } from 'react'
import styled from 'styled-components'
import SessionDialog from '../../sessions/components/SessionDialog'

const Field = styled.div`
  margin-bottom: 12px;
`
const Label = styled.label`
  display: block;
  font-size: 12px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.06em;
  color: ${(p) => p.theme?.color?.inkMuted || '#6B7280'};
  margin-bottom: 4px;
`
const Input = styled.input`
  width: 100%;
  padding: 10px 12px;
  border-radius: 10px;
  border: 1px solid ${(p) => p.theme?.color?.border || '#E6E0D6'};
  font-family: inherit;
  font-size: 14px;
`
const TextArea = styled.textarea`
  width: 100%;
  min-height: 60px;
  padding: 10px 12px;
  border-radius: 10px;
  border: 1px solid ${(p) => p.theme?.color?.border || '#E6E0D6'};
  font-family: inherit;
  font-size: 14px;
  resize: vertical;
`

export default function GoalCheckInDialog({ open, goal, onClose, onSubmit }) {
  const [value, setValue] = useState('')
  const [note, setNote] = useState('')
  const [busy, setBusy] = useState(false)

  async function handle() {
    setBusy(true)
    try {
      await onSubmit({
        value: value === '' ? null : Number(value),
        note: note.trim() || null,
      })
      setValue('')
      setNote('')
      onClose()
    } finally {
      setBusy(false)
    }
  }

  if (!goal) return null

  return (
    <SessionDialog
      open={open}
      title={`Check in on ${goal.title}`}
      subtitle={
        goal.targetValue
          ? `Target ${goal.targetValue}${goal.unit ? ` ${goal.unit}` : ''}.`
          : null
      }
      primaryLabel="Check in"
      primaryLoading={busy}
      onPrimary={handle}
      onClose={onClose}
    >
      <Field>
        <Label>Where are you now?{goal.unit ? ` (${goal.unit})` : ''}</Label>
        <Input
          value={value}
          onChange={(e) => setValue(e.target.value)}
          placeholder={goal.currentValue?.toString() || '0'}
          inputMode="decimal"
        />
      </Field>
      <Field>
        <Label>Note (optional)</Label>
        <TextArea
          value={note}
          onChange={(e) => setNote(e.target.value)}
          placeholder="Anything that helped or got in the way"
        />
      </Field>
    </SessionDialog>
  )
}
